import { isBuild, typeViteEnv } from '@/utils/env'
import { hasClass, removeClass } from '../utils'
import VideoEnPlayer from '../Player'
import VideoEvents from '../event'

const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/resource/image'

export function clickContainer(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$video, 'click', () => {
      if (events.dragFixed) {
        player.player.pause()
        events.layerDom.toggleCommonLayer(player.template.$miniLayer, true)
      } else {
        if (player.player.getStatus() === 'playing' || player.player.getStatus() === 'pause') {
          events.clearSetTimeOut()
          if (hasClass(player.template.$container.parentNode as HTMLElement, 'init')) { return }
          if (hasClass(player.template.$bottom, 'none')) {
            events.layerDom.tooglePlayerBottom(true)
            events.layerDom.tooglePlayerBottom(false, true)
          } else {
            events.layerDom.tooglePlayerBottom(false)
          }
        }
      }
    })
  }
}

export function clickErrorBlock(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$error, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()
    })
  }
}


export function clickErrorBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$errorBtn, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()
    })
  }
}

export function clickNetworkBlock(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$network, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()
    })
  }
}

export function clickNetworkBlockBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$networkBtn, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (!events.dragFixed) {
        events.clearSetTimeOut()

        removeClass(player.template.$container.parentNode as HTMLElement, 'init')

        player.callBackFun.continueNetwork()

        events.layerDom.toggleLayerPause(false)

        events.layerDom.tooglePlayerBottom(true)

        events.layerDom.tooglePlayerBottom(false, true)

        player.player.play()

        setTimeout(() => {
          player.player.play()
        }, 100)
      }
    })
  }
}

export function clickLayerStateBlock(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$layerState, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (!events.dragFixed) {
        events.clearSetTimeOut()
        if (player.player.getStatus() !== 'playing') {
          player.callBackFun.closeFixModal(player.options.record.id)
          player.player.play()
          events.layerDom.toggleLayerPause(false)
          events.layerDom.tooglePlayerBottom(true)
          events.layerDom.tooglePlayerBottom(false, true)
        } else if (player.player.getStatus() === 'playing') {
          player.player.pause()
          events.layerDom.toggleCommonLayer(player.template.$miniLayer, true)
          events.layerDom.toggleLayerPause(true)
          events.layerDom.tooglePlayerBottom(false, true)
        }
      }
    })
  }
}

export function clickLayerStateBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$layerStateBtn, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (!events.dragFixed) {
        events.clearSetTimeOut()
        player.callBackFun.closeFixModal(player.options.record.id)
        player.player.play()
        events.layerDom.toggleLayerPause(false)
        events.layerDom.tooglePlayerBottom(true)
        events.layerDom.tooglePlayerBottom(false, true)
      }
    })
  }
}

export function clickBottomState(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$bottomState, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (player.player) {
        if (!events.dragFixed) {
          events.layerDom.tooglePlayerBottom(true)
          events.clearSetTimeOut()
          if (player.player.getStatus() === 'playing') {
            player.player.pause()
            player.template.$bottomState.setAttribute('src', `${publicImageUrl}/player/video_puse.svg`)
          } else {
            player.player.play()
            player.template.$bottomState.setAttribute('src', `${publicImageUrl}/player/video_play.svg`)
          }
          events.layerDom.tooglePlayerBottom(false, true)
        }
      }
    })
  }
}

export function clickBottonFullScreen(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$bottomFullScreen, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (!events.dragFixed) {
        events.layerDom.tooglePlayerBottom(true)
        events.clearSetTimeOut()

        if (player.player.fullscreenService.getIsFullScreen() as any) {
          const bg = player.template.$container.getAttribute('old-bg')
          player.template.$container.setAttribute('old-bg', '')
          player.template.$container.style.backgroundColor = bg
          player.player.fullscreenService.cancelFullScreen()
        } else {
          player.player.fullscreenService.requestFullScreen()
          player.template.$container.setAttribute('old-bg', player.template.$container.style.backgroundColor)
          player.template.$container.style.backgroundColor = '#000'
        }

        events.layerDom.tooglePlayerBottom(false, true)
      }
    })
  }
}

export function clickReplayBlock(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$replay, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()
    })
  }
}

export function clickReplayBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$replayBtn, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (!events.dragFixed) {
        events.clearSetTimeOut()

        events.layerDom.toggleCommonLayer(player.template.$replay, false)
        events.layerDom.toggleBottomPlayState(true)
        events.layerDom.tooglePlayerBottom(true)
        events.layerDom.tooglePlayerBottom(false, true)

        player.player?.seek(0)
        player.player?.play()

        setTimeout(() => {
          events.layerDom.toggleBottomPlayState(true)
          events.layerDom.tooglePlayerBottom(true)
          events.layerDom.tooglePlayerBottom(false, true)
        }, 50)
      }
    })
  }
}

export function clickMiniLayerBlcok(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$miniLayer, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (player.player.getStatus() === 'pause') {
        player.player.play()
        events.layerDom.toggleCommonLayer(player.template.$miniLayer, false)
      } else if (player.player.getStatus() === 'playing') {
        player.player.pause()
        events.layerDom.toggleCommonLayer(player.template.$miniLayer, true)
      }
    })
  }
}

export function clickMiniLayerBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$miniLayerBtn, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      player.player.play()

      events.layerDom.toggleCommonLayer(player.template.$miniLayer, false)
    })
  }
}

export function clickMiniCloseBtn(player: VideoEnPlayer, events: VideoEvents) {
  if (player.player) {
    events.proxy(player.template.$miniClose, 'click', (e) => {
      e.stopImmediatePropagation()
      e.stopPropagation()

      if (events.dragFixed) {
        player.callBackFun.closeFixModal(player.options.record.id)
      }
    })
  }
}
